// Bulgarian fiscal devices via the free local ErpNet.FP server (supports Datecs, Tremol, Daisy, Eltrade, Incotex).
const base = (cfg) => (cfg.url || "").replace(/\/$/, "");

export async function fiscalPrinters(cfg) {
  const r = await fetch(`${base(cfg)}/printers`);
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

export async function sendFiscalReceipt(cfg, order) {
  const p = order.payment;
  const pct = p.discount_pct || 0;
  const items = order.items.map((i) => ({
    text: (i.name_bg || i.name).slice(0, 36), quantity: i.quantity, unitPrice: Number(i.price.toFixed(2)),
    taxGroup: Number(cfg.tax_groups?.[i.vat_rate ?? 20] ?? 2),
    ...(pct ? { priceModifierValue: pct, priceModifierType: "DiscountPercent" } : {}),
  }));
  const r = await fetch(`${base(cfg)}/printers/${cfg.printer_id}/receipt`, {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items, payments: [{ amount: p.amount, paymentType: p.method === "CASH" ? "cash" : "card" }] }),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok || data.ok === false) throw new Error((data.messages || []).map((m) => m.text).join("; ") || `HTTP ${r.status}`);
  return data;
}
